[<AutoOpen>]
module Shared.GridTypes

open System

type SearchString = SearchString of string 
module SearchString = 
    let unwrap = function SearchString str -> str
    let isEmpty (SearchString str) = String.IsNullOrEmpty str
    let empty = SearchString ""
    let ofString = Option.defaultValue "" >> SearchString
    let toString (SearchString str) = if String.IsNullOrWhiteSpace str then None else Some str

type PageNo = PageNo of int 
module PageNo = 
    let unwrap = function PageNo x -> x
type PageSize = PageSize of int 
module PageSize = 
    let unwrap = function PageSize x -> x
type IncludeHidden = IncludeHidden of bool 
module IncludeHidden = 
    let unwrap = function IncludeHidden x -> x
type RecordCount = RecordCount of int 
module RecordCount = 
    let unwrap = function RecordCount x -> x
type ShowAcrossAllEpisodes = ShowAcrossAllEpisodes of bool
module ShowAcrossAllEpisodes = 
    let unwrap = function ShowAcrossAllEpisodes x -> x